import React, { FC, ReactElement, useContext } from 'react'
import { CustomiseRole as CustomiseRoleLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import Button from '../../Common/Components/Button'
import { LanguageContext } from '../../Common/Contexts'

type Props = {
    closeModal: () => void
}

/**
 * Footer actions for the customise role popup.
 *
 * @param closeModal - Close modal function.
 */
export const FooterActions: FC<Props> = ({ closeModal }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('CustomiseRole')

    const handleHelpClick = (): void => {
        // TODO: Handle help click
    }

    return (
        <div className='tabs-footer'>
            <Button label={language.get(CustomiseRoleLanguage.FooterActionsHelp)} onClick={handleHelpClick} />
            <Button label={language.get(CustomiseRoleLanguage.FooterActionsSubmit)} type='submit' />
            <Button isOutlined label={language.get(CustomiseRoleLanguage.FooterActionsCancel)} onClick={closeModal} />
        </div>
    )
}
